var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5999 3.01049C6.5999 3.58602 6.10741 4.05259 5.4999 4.05259C4.89239 4.05259 4.3999 3.58602 4.3999 3.01049C4.3999 2.43496 4.89239 1.96838 5.4999 1.96838C6.10741 1.96838 6.5999 2.43496 6.5999 3.01049",
    fill: "#8D8D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9027 2.75072C10.4314 2.23829 9.90683 1.77865 9.33812 1.37993C8.06138 0.477244 6.73453 0 5.49997 0C4.2654 0 2.93851 0.477222 1.66247 1.37993C1.0936 1.77865 0.568803 2.23827 0.0972853 2.75072C0.0346163 2.82242 0 2.91483 0 3.01053C0 3.10622 0.0346163 3.19862 0.0972853 3.27033C0.568869 3.78276 1.0936 4.24231 1.66247 4.64112C2.93862 5.54407 4.26606 6.02105 5.50062 6.02105C6.73523 6.02105 8.06143 5.54383 9.33812 4.64112C9.90675 4.24231 10.4313 3.78278 10.9027 3.27033C10.9654 3.19863 11 3.10622 11 3.01053C11 2.91483 10.9654 2.82243 10.9027 2.75072ZM5.49998 4.87483C5.49997 4.87483 5.49996 4.87484 5.49995 4.87484C5.0113 4.87483 4.54278 4.67845 4.19721 4.32883C3.85173 3.97913 3.65766 3.505 3.65766 3.0105C3.65766 2.51601 3.85172 2.04188 4.19721 1.69218C4.54279 1.34256 5.01131 1.14617 5.49997 1.14617C5.98862 1.14617 6.45715 1.34255 6.80272 1.69218C7.14821 2.04188 7.34228 2.51601 7.34228 3.0105C7.34176 3.50482 7.14745 3.97869 6.80204 4.32813C6.45674 4.67765 5.98848 4.8743 5.5 4.87482C5.49999 4.87482 5.49999 4.87482 5.49998 4.87483V4.87483Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDark);
export default __webpack_public_path__ + "static/media/eye-dark.268e551ba98baa621f008286a16b341f.svg";
export { ForwardRef as ReactComponent };